export default __webpack_public_path__ + "static/media/peep-12.7d721ff5.svg";